import { render, staticRenderFns } from "./PaginaTipologieVendita.vue?vue&type=template&id=0c2068d2&"
import script from "./PaginaTipologieVendita.vue?vue&type=script&lang=js&"
export * from "./PaginaTipologieVendita.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTipologieVendita.vue?vue&type=style&index=0&id=0c2068d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports